import { createEnv } from "@t3-oss/env-nextjs"
import { z } from "zod/v4"
import { env as clientEnv } from "./client"
import { requiredInProduction } from "./utils"

export const env = {
  ...createEnv({
    server: {
      RESTRICT_EXTERNAL_EMAILS: z.stringbool().default(false),
      BETTER_AUTH_SECRET: z.string(),
      BETTER_AUTH_URL: z.url(),
      DATABASE_URL: z.url(),
      RESEND_API_KEY: z.string(),
      POLAR_WEBHOOK_SECRET: z.string(),
      POLAR_ACCESS_TOKEN: z.string(),
      POLAR_SERVER: z.enum(["sandbox", "production"]),
      GOOGLE_CLIENT_ID: z.string(),
      GOOGLE_CLIENT_SECRET: z.string(),
      CLOUDFLARE_ACCOUNT_ID: z.string(),
      CLOUDFLARE_R2_ACCESS_KEY_ID: z.string(),
      CLOUDFLARE_R2_SECRET_ACCESS_KEY: z.string(),
      CLOUDFLARE_R2_BUCKET_NAME: z.string(),
      AFFONSO_PROGRAM_ID: z.string().optional().check(requiredInProduction),
      RAPID_API_KEY: z.string(),
      APIFY_API_TOKEN: z.string(),
      NOVU_SECRET_KEY: z.string(),
      FIRECRAWL_API_KEY: z.string(),
      GOOGLE_GENERATIVE_AI_API_KEY: z.string(),
      ADMIN_USER_ID: z.string(),
      N8N_BEARER_TOKEN: z.string(),
      N8N_BASE_URL: z.url(),
      LOOPS_API_KEY: z.string(),
      INNGEST_SIGNING_KEY: z.string().optional(),
      INNGEST_EVENT_KEY: z.string().optional(),
      INNGEST_ENV: z.string().optional(),
      INNGEST_DEV: z.stringbool().optional(),
      VERCEL_GIT_COMMIT_REF: z.string().optional(),
      VERCEL_ENV: z.string(),
    },
    experimental__runtimeEnv: process.env,
    emptyStringAsUndefined: true,
  }),
  ...clientEnv,
}
